import { Link } from 'react-router-dom';

export default function FaqBottomCta() {
  const ctaCards = [
    {
      title: 'Contact Us',
      description: 'Still have questions? Our team is here to help you.',
      icon: 'ri-customer-service-2-line',
      buttonText: 'Get in Touch',
      buttonLink: '/contact',
      color: 'from-[#1C2B1E] to-[#2d4430]',
    },
    {
      title: 'Get Financing',
      description: 'Get approved and know your budget before you shop.',
      icon: 'ri-calculator-line',
      buttonText: 'Apply Now',
      buttonLink: '/financing',
      color: 'from-[#E8B84B] to-[#d4a43d]',
    },
    {
      title: 'Browse Inventory',
      description: 'Ready to find your perfect vehicle? Start browsing now.',
      icon: 'ri-car-line',
      buttonText: 'View Cars',
      buttonLink: '/inventory',
      color: 'from-[#1C2B1E] to-[#2d4430]',
    },
  ];

  return (
    <div className="bg-[#F7F5F0] py-12 border-t border-[#E8E2D6]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="font-['Oswald'] text-3xl sm:text-4xl font-bold text-[#1C2B1E] mb-2">
            Ready to Take the Next Step?
          </h2>
          <p className="text-[#374151] max-w-2xl mx-auto">
            Whether you need help, financing, or want to browse our inventory, we&apos;re here for you.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {ctaCards.map((card, index) => (
            <div
              key={index}
              className={`bg-gradient-to-br ${card.color} rounded-2xl p-8 text-white text-center`}
            >
              <div
                className="inline-flex items-center justify-center w-16 h-16 bg-white/20 rounded-full mb-4"
                aria-hidden="true"
              >
                <i className={`${card.icon} text-3xl`}></i>
              </div>
              <h3 className="font-['Oswald'] text-2xl font-bold mb-2">
                {card.title}
              </h3>
              <p className="text-white/90 mb-6 text-sm">
                {card.description}
              </p>
              <Link
                to={card.buttonLink}
                className="inline-flex items-center gap-2 px-6 py-3 bg-white text-[#1C2B1E] rounded-full font-medium hover:bg-white/90 transition-colors whitespace-nowrap cursor-pointer"
              >
                {card.buttonText}
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
